<template>
  <div space-y-4>
    <div grid grid-flow-dense sm:grid-cols-2 gap-2>
      <DataItem col-span-2 :loading="true" label="Address">
        <br />
        <br />
      </DataItem>
      <DataItem col-span-2 sm:col-span-1 :loading="true" label="Phone Number" value=" " />
      <DataItem col-span-2 sm:col-span-1 :loading="true" label="Website" value=" " valueClass="text-xl sm:text-2xl" />
      <DataItem col-span-2 sm:col-span-1 :loading="true" label="Schools" value=" " />
    </div>
  </div>
</template>
